/* SST cart drawer.
   Speed rules:
   - Every tap updates the drawer at once (quantity, line price, total, count). The
     server call runs behind it and the drawer reconciles when the queue is empty.
   - Removing a line collapses it immediately.
   - Section re-renders are applied only when the HTML changed, and existing <img>
     nodes are reused (matched by file name), so photos never reload or flash.
   - The drawer opens the moment any add-to-cart request starts, shows the new line
     from the add response, then reconciles.
   - Cart photos and upsell recommendations are fetched while the page is idle.
   Other code can still call window.renderCart() and window.SSTCart.open/close/refresh. */
(function () {
  'use strict';
  if (window.SSTCart) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'cart-drawer';
  var recCache = {}, recLoading = {};
  var refreshing = null, lastHTML = '';
  var _fetch = window.fetch.bind(window);

  function el() { return document.querySelector('[data-sstc]'); }
  function wrap() { var d = el(); return d && d.querySelector('.drawer__wrapper'); }
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fileKey(src) { var m = (src || '').split('?')[0].match(/[^/]+$/); return m ? m[0] : ''; }

  /* ---------- reconcile with server HTML ---------- */
  function swap(html) {
    var d = el(), w = wrap();
    if (!d || !w || !html || html === lastHTML) return;
    var wait = holdUntil - performance.now();
    clearTimeout(swap.t);
    if (wait > 0) { swap.t = setTimeout(function () { swap(html); }, wait + 16); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nd = doc.querySelector('[data-sstc]');
    var nw = nd && nd.querySelector('.drawer__wrapper');
    if (!nw) return;
    lastHTML = html;
    var sc = w.querySelector('.sc-scroll'), top = sc ? sc.scrollTop : 0;

    // reuse decoded images (cart lines and upsell tiles) so nothing reloads
    var pool = {};
    w.querySelectorAll('img').forEach(function (i) { var k = fileKey(i.getAttribute('src')); if (k && !pool[k]) pool[k] = i; });
    nw.querySelectorAll('img').forEach(function (i) {
      var k = fileKey(i.getAttribute('src')), old = pool[k];
      if (old && old.complete && old.naturalWidth) { delete pool[k]; i.replaceWith(old); }
    });
    // keep the tax-exempt app's button and the loaded upsell grid as live nodes
    var oldTax = w.querySelector('.tax-exempt-popup-target');
    var newTax = nw.querySelector('.tax-exempt-popup-target');
    if (oldTax && newTax && oldTax.hasChildNodes()) newTax.replaceWith(oldTax);
    var oldGrid = w.querySelector('[data-ups-grid]'), newGrid = nw.querySelector('[data-ups-grid]');
    var oldBox = w.querySelector('[data-ups]');
    if (oldGrid && newGrid && oldGrid.children.length) {
      newGrid.replaceWith(oldGrid);
      if (oldBox && !oldBox.hidden) nw.querySelector('[data-ups]').hidden = false;
    }

    w.replaceChildren.apply(w, Array.prototype.slice.call(nw.childNodes));
    d.classList.toggle('is-empty', nd.classList.contains('is-empty'));
    d.setAttribute('data-count', nd.getAttribute('data-count') || '0');
    var nsc = w.querySelector('.sc-scroll'); if (nsc) nsc.scrollTop = top;
    if (pop) {
      var since = performance.now() - pop.t0;
      var nl = w.querySelector('.sc-scroll .sc-line[data-vid="' + pop.vid + '"][data-n="' + pop.n + '"]');
      if (nl && since < POP_MS) {
        startPop(popTarget(nl), -since);
        if (nsc && since < 0) nsc.scrollTo({ top: pop.goal, behavior: 'smooth' });
      }
      if (since >= POP_MS) pop = null;
    }
    updateCount(+(nd.getAttribute('data-count') || 0));
    loadUpsells(null, true);
  }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (s) {
      s.textContent = s.classList.contains('d-count') ? '(' + n + ')' : n;
    });
    var b = document.querySelector('[data-cart-count-bubble]');
    if (b) b.classList.toggle('hide', n === 0);
    document.querySelectorAll('[data-sc-count]').forEach(function (s) { s.textContent = n; s.hidden = n === 0; s.classList.toggle('is-2', n > 9 && n < 100); s.classList.toggle('is-3', n > 99); });
  }
  function bumpCount(delta) {
    var d = el(); if (!d) return;
    var n = Math.max(0, (+d.getAttribute('data-count') || 0) + delta);
    d.setAttribute('data-count', n); updateCount(n);
  }
  function bumpTotal(delta) {
    var co = wrap() && wrap().querySelector('.sc-co'); if (!co || !delta) return;
    var t = (+co.getAttribute('data-total') || 0) + delta;
    co.setAttribute('data-total', t);
    var tt = co.querySelector('[data-total-text]'); if (tt) tt.textContent = money(t);
  }

  /* ---------- server calls ---------- */
  function post(url, body) {
    return _fetch(ROOT + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function refresh() {
    if (refreshing) return refreshing;
    refreshing = _fetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!running) swap(j[SECTION]); resetAddButtons(); })
      .catch(function (e) { console.error('[sst-cart] refresh', e); })
      .then(function () { refreshing = null; });
    return refreshing;
  }

  /* ---------- quantity changes: instant on screen, queued to the server ---------- */
  var queue = [], running = false, pendingHTML = null;
  function stepFor(op) {
    var w = wrap(); if (!w) return null;
    var sel = '.sc-step[data-vid="' + op.vid + '"][data-n="' + op.n + '"]';
    return w.querySelector('.sc-scroll ' + sel) || w.querySelector('.sc-grave ' + sel);
  }
  function shown(step) { return parseInt(step.querySelector('input').value, 10) || 0; }

  function paint(step, qty) {
    // update the line on screen right away
    var input = step.querySelector('input');
    var before = shown(step);
    input.value = qty;
    var unit = +step.getAttribute('data-unit') || 0, wunit = +step.getAttribute('data-wunit') || 0;
    var line = step.closest('.sc-size') ? null : step.closest('.sc-line');
    if (line && unit) {
      var now = line.querySelector('.sc-now'), was = line.querySelector('.sc-price s');
      if (now) now.textContent = money(unit * qty);
      if (was && wunit) was.textContent = money(wunit * qty);
      bumpTotal(unit * (qty - before));
    }
    bumpCount(qty - before);
    if (qty === 0) collapse(step.closest('.sc-size') || line);
    else if (line && nativeOn()) { var rc = line.closest('.sc-card[data-rule]'); if (rc) reprice(rc); repriceSolo(); }
  }
  function collapse(node) {
    if (!node || node.classList.contains('is-gone')) return;
    var card = node.closest('.sc-card');
    var onlyLine = card && node.classList.contains('sc-line') && card.querySelectorAll('.sc-line:not(.is-gone)').length === 1;
    if (!onlyLine && card && card.getAttribute('data-card') === 'bundle' && node.classList.contains('sc-line')) { leaveBundle(node, card); return; }
    // fade it, then take it out of the layout and glide everything below up into place
    hold(900);
    var target = onlyLine ? card : node;
    if (!onlyLine && card) clipCard(card);
    target.classList.add('is-gone');
    // let the exit play out, then close the gap with a springy glide
    setTimeout(function () { flip(function () { bury(target); repriceSolo(); }, true); }, 200);
  }
  /* A removed line leaves the layout but stays queryable: a queued request may
     still need its stepper's key. The next server render drops it for good. */
  function bury(node) {
    var w = wrap(); if (!w) return;
    var g = w.querySelector('.sc-grave');
    if (!g) { g = document.createElement('div'); g.className = 'sc-grave'; g.hidden = true; w.appendChild(g); }
    g.appendChild(node);
  }

  /* Keep the server re-render from landing in the middle of an animation. */
  var holdUntil = 0;
  function hold(ms) { holdUntil = Math.max(holdUntil, performance.now() + ms); }

  /* Removing one product from a bundle: fade it out, then settle everything into
     the layout the server is about to send (partner loses its discount, splits into
     its own card, cards reorder) and glide each card from where it was to where it
     ends up. The server HTML then matches what's on screen. */
  function clipCard(card) { card.classList.add('is-clip'); setTimeout(function () { card.classList.remove('is-clip'); }, 900); }
  function leaveBundle(line, card) {
    hold(900);
    clipCard(card);
    var title = (card.querySelector('.sc-disc span') || {}).textContent || '';
    line.classList.add('is-gone');
    setTimeout(function () {
      flip(function () {
        bury(line);
        var rest = Array.prototype.slice.call(card.querySelectorAll('.sc-line'));
        var ok = nativeOn() && card.getAttribute('data-rule') ? reprice(card) : rebundle(card, rest, title);
        if (!ok && adopt(card, rest, title)) { rest = Array.prototype.slice.call(card.querySelectorAll('.sc-line')); ok = rebundle(card, rest, title); }
        if (!ok) {
          card.removeAttribute('data-card'); card.removeAttribute('data-rule');
          rest.slice(1).reverse().forEach(function (l) { var c = document.createElement('div'); c.className = 'sc-card'; c.appendChild(l); card.after(c); });
        }
        orderCards();
        repriceSolo();
      }, true);
    }, 200);
  }
  // Bundler re-forms the bundle with a spare copy elsewhere in the cart (e.g. a second MEGAFLOW)
  function adopt(card, rest, title) {
    var w = wrap(), pids = rest.map(function (l) { return l.getAttribute('data-pid'); });
    var b = bundles.filter(function (x) { return x.name === title && !x.tiers && x.type === 'percentage' && pids.some(function (p) { return x.pids.indexOf(p) >= 0; }); })[0];
    if (!b) return false;
    var have = {}; pids.forEach(function (p) { if (b.pids.indexOf(p) >= 0) have[p] = 1; });
    var spare = Array.prototype.filter.call(w.querySelector('.sc-scroll').querySelectorAll('.sc-card:not([data-card]) .sc-line[data-pid]'), function (l) {
      var p = l.getAttribute('data-pid');
      return l.closest('.sc-card') !== card && b.pids.indexOf(p) >= 0 && !have[p] && !l.querySelector('.sc-bottom.has-disc');
    });
    var add = [];
    spare.forEach(function (l) { var p = l.getAttribute('data-pid'); if (!have[p]) { have[p] = 1; add.push(l); } });
    if (Object.keys(have).length < (b.min || 2)) return false;
    add.forEach(function (l) { var old = l.closest('.sc-card'); card.appendChild(l); if (!old.querySelector('.sc-line')) old.remove(); });
    // keep cart order inside the card
    Array.prototype.slice.call(card.querySelectorAll('.sc-line')).sort(function (a, c) { return +a.getAttribute('data-i') - +c.getAttribute('data-i'); }).forEach(function (l) { card.appendChild(l); });
    return true;
  }
  function lineOrig(l) {
    var st = l.querySelector('.sc-step'), inp = st && st.querySelector('input');
    var sq = inp ? (parseInt(inp.getAttribute('value'), 10) || 1) : 1, q = inp ? (parseInt(inp.value, 10) || 0) : sq;
    return Math.round((+l.getAttribute('data-orig') || 0) / sq * q);
  }
  // does what's left in the card still earn the bundle discount? re-price it either way
  function rebundle(card, rest, title) {
    var pids = rest.map(function (l) { return l.getAttribute('data-pid'); });
    var b = bundles.filter(function (x) { return x.name === title && pids.some(function (p) { return x.pids.indexOf(p) >= 0; }); })[0];
    var pct = 0, members = rest.filter(function (l) { return b && b.pids.indexOf(l.getAttribute('data-pid')) >= 0; });
    if (b && b.type === 'percentage') {
      if (b.tiers) {
        var q = 0; members.forEach(function (l) { q += parseInt(l.querySelector('input').value, 10) || 0; });
        if (members.length > 1) b.tiers.forEach(function (t) { if (q >= t.min && t.pct > pct) pct = t.pct; });
      } else {
        var seen = {}; members.forEach(function (l) { seen[l.getAttribute('data-pid')] = 1; });
        if (Object.keys(seen).length >= (b.min || 2)) pct = b.pct;
      }
    }
    if (pct) {
      var offs = allocate(members, pct);
      members.forEach(function (l, i) { bumpTotal(setDiscount(l, offs[i], b.name)); });
      return true;
    }
    rest.forEach(function (l) { bumpTotal(clearDiscount(l)); });
    return false;
  }
  function clearDiscount(l) {
    var price = l.querySelector('.sc-price'), now = price && price.querySelector('.sc-now'); if (!now) return 0;
    var before = parsePrice(now.textContent), orig = lineOrig(l);
    now.textContent = money(orig); now.classList.remove('is-g');
    // the product's own sale price (compare-at) stays struck through; only the bundle strike goes
    var q = qtyOf(l) || 1, cmp = (+l.getAttribute('data-cmp') || 0) * q;
    var s = price.querySelector('s');
    if (cmp > orig) { if (!s) { s = document.createElement('s'); price.appendChild(s); } s.textContent = money(cmp); }
    else if (s) s.remove();
    var bottom = l.querySelector('.sc-bottom'); bottom.classList.remove('has-disc');
    var cap = bottom.querySelector('.sc-disc'); if (cap) cap.remove();
    var st = l.querySelector('.sc-step'); if (st) st.setAttribute('data-unit', Math.round(orig / (parseInt(st.querySelector('input').value, 10) || 1)));
    return orig - before;
  }
  // Shopify lists cards in cart order (a card sits where its earliest line is)
  function orderCards() {
    var w = wrap(), sc = w && w.querySelector('.sc-scroll'); if (!sc) return;
    var cards = Array.prototype.filter.call(sc.children, function (c) { return c.classList.contains('sc-card') && c.getAttribute('data-card') !== 'grabrail'; });
    if (cards.length < 2) return;
    var at = function (c) { return Math.min.apply(null, Array.prototype.map.call(c.querySelectorAll('.sc-line[data-i]'), function (l) { return +l.getAttribute('data-i'); }).concat([1e9])); };
    var ref = cards[0].previousElementSibling;
    cards.slice().sort(function (a, b) { return at(a) - at(b); }).forEach(function (c) { if (ref) ref.after(c); else sc.prepend(c); ref = c; });
  }
  /* FLIP: measure, change the DOM, then animate each card from its old spot and
     height to the new one. Height changes are paired with an opposite margin so
     the cards below are moved by their own transform, never by layout. */
  function flip(mutate, springy) {
    var w = wrap(), sc = w && w.querySelector('.sc-scroll'); if (!sc) { mutate(); return; }
    var track = function () { return Array.prototype.slice.call(sc.children).concat(Array.prototype.slice.call(sc.querySelectorAll('.sc-card > .sc-line'))); };
    var before = new Map();
    track().forEach(function (e) { var r = e.getBoundingClientRect(); before.set(e, { top: r.top, h: r.height }); });
    mutate();
    var moves = [];
    Array.prototype.forEach.call(sc.children, function (el) {
      var b = before.get(el), r = el.getBoundingClientRect();
      if (!b && el.classList.contains('sc-card')) {
        // a card split off from the bundle: start it where its line was
        var l = el.querySelector('.sc-line'), lb = l && before.get(l);
        if (lb) { var lr = l.getBoundingClientRect(); b = { top: r.top + (lb.top - lr.top), h: r.height }; }
      }
      if (!b) return;
      var dy = b.top - r.top, dh = b.h - r.height;
      if (Math.abs(dy) < 0.5 && Math.abs(dh) < 0.5) return;
      moves.push({ el: el, dy: dy, dh: dh, h: r.height });
    });
    moves.forEach(function (m) {
      var st = m.el.style;
      st.transition = 'none'; st.transform = 'translateY(' + m.dy + 'px)';
      if (Math.abs(m.dh) >= 0.5) { st.height = (m.h + m.dh) + 'px'; st.marginBottom = (-m.dh) + 'px'; st.overflow = 'hidden'; }
    });
    void sc.offsetHeight;
    var ease = '.32s cubic-bezier(.2,.8,.2,1)';
    var move = springy ? '.46s cubic-bezier(.34,1.45,.64,1)' : ease;   // overshoots a little, then settles
    moves.forEach(function (m) {
      var st = m.el.style;
      st.transition = 'transform ' + move + ', height ' + ease + ', margin-bottom ' + ease;
      st.transform = '';
      if (st.height) { st.height = m.h + 'px'; st.marginBottom = '0px'; }
    });
    setTimeout(function () { moves.forEach(function (m) { var st = m.el.style; st.transition = st.transform = st.height = st.marginBottom = st.overflow = ''; }); }, springy ? 500 : 360);
  }

  function enqueue(op) {
    var step = stepFor(op); if (!step) return;
    var cur = shown(step);
    var qty = op.kind === 'inc' ? cur + 1 : op.kind === 'dec' ? Math.max(0, cur - 1) : op.kind === 'rm' ? 0 : op.value;
    if (qty === cur && op.kind !== 'rm') return;
    paint(step, qty);
    op.qty = qty;
    // collapse repeated taps on the same line into one request
    for (var i = queue.length - 1; i >= 0; i--) {
      if (queue[i].vid === op.vid && queue[i].n === op.n) { queue[i].qty = qty; return; }
    }
    queue.push(op);
    if (!running) run();
  }

  /* Bundler re-tags the cart by line number for a few seconds after each change.
     Writing while it does that makes it hit the wrong line (units vanish), so our
     writes wait for it to go quiet. The screen updates instantly either way. */
  var settleUntil = 0, outsideInflight = 0;
  function settle(ms) { if (!bundles.length) return; settleUntil = Math.max(settleUntil, performance.now() + ms); }
  function whenSettled() {
    // Only Bundler needed this (it re-tags lines after every edit). Without it, other apps' cart
    // writes (UpPush saves attributes on every page load) must never hold up an add.
    if (!bundles.length) return Promise.resolve();
    return new Promise(function (res) {
      (function chk() {
        var w = settleUntil - performance.now();
        if (w <= 0 && !outsideInflight) res(); else setTimeout(chk, Math.max(60, Math.min(w, 400)));
      })();
    });
  }
  function busyWriting() { return running || queue.length > 0 || addPending > 0; }
  var addPending = 0;

  function run() {
    if (!queue.length) {
      running = false;
      if (outsideDirty) { outsideDirty = false; pendingHTML = null; lastHTML = ''; refresh(); }
      else if (pendingHTML) { var h = pendingHTML; pendingHTML = null; swap(h); }
      return;
    }
    running = true;
    whenSettled().then(function () { var op = queue.shift(); if (op) runOp(op); else run(); });
  }
  function runOp(op) {
    var step = stepFor(op);
    if (!step) { run(); return; }
    var key = step.getAttribute('data-key');
    var server = parseInt(step.querySelector('input').getAttribute('value'), 10) || 0;
    var qty = op.qty;
    var req;
    var keysAttr = step.getAttribute('data-keys');
    if (keysAttr && /^pk/.test(op.n)) {
      // one line on screen standing for several cart lines (Bundler splits repeat adds):
      // + adds a unit, − takes units off the last lines first
      if (qty > server) req = post('cart/add.js', { items: [{ id: +op.vid, quantity: qty - server }], sections: SECTION });
      else {
        var ks = keysAttr.split(',').filter(Boolean), qs = (step.getAttribute('data-qs') || '').split(',').filter(Boolean).map(Number);
        var d = server - qty, upd = {};
        for (var x = ks.length - 1; x >= 0 && d > 0; x--) { var take = Math.min(qs[x] || 0, d); upd[ks[x]] = (qs[x] || 0) - take; qs[x] = (qs[x] || 0) - take; d -= take; }
        step.setAttribute('data-qs', qs.join(','));
        req = post('cart/update.js', { updates: upd, sections: SECTION });
      }
    } else if (op.n === 'pack') {
      // Shopify splits one twist-lock size into a free and a paid line; add through
      // /cart/add, remove from the last line.
      var lq = parseInt(step.getAttribute('data-lq'), 10) || server;
      if (qty > server) req = post('cart/add.js', { items: [{ id: +op.vid, quantity: qty - server }], sections: SECTION });
      else req = post('cart/change.js', { id: key, quantity: Math.max(0, lq - (server - qty)), sections: SECTION });
    } else if (qty === server) {
      run(); return;
    } else {
      req = post('cart/change.js', { id: key, quantity: qty, sections: SECTION });
    }
    req.then(function (res) {
      if (!res.ok && !op.retried && op.n !== 'pack') {
        // another app (Bundler) re-keyed the cart under us: look the line up again and retry once
        op.retried = true;
        return _fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          syncKeys(cart); queue.unshift(op);
        });
      }
      if (!res.ok) { flash(res.j.description || res.j.message || 'Couldn’t update the cart.'); queue = []; pendingHTML = null; running = false; lastHTML = ''; return refresh(); }
      settle(3200);
      var html = res.j.sections && res.j.sections[SECTION];
      if (res.j.items && res.j.token) syncKeys(res.j); // change.js returns the whole cart
      pendingHTML = html; // applied once the queue is empty
    })
    .catch(function () { flash('Couldn’t reach the cart. Check your connection.'); lastHTML = ''; return refresh(); })
    .then(function () { if (running) run(); });
  }

  // After each server change, Shopify may re-key lines. Update keys and confirmed
  // quantities in place so the next queued request targets the right line.
  function syncKeys(cart) {
    var w = wrap(); if (!w) return;
    var byVid = {};
    cart.items.forEach(function (it) { (byVid[it.variant_id] = byVid[it.variant_id] || []).push(it); });
    w.querySelectorAll('.sc-scroll .sc-step[data-vid]').forEach(function (s) {
      var list = byVid[s.getAttribute('data-vid')] || [], n = s.getAttribute('data-n');
      var input = s.querySelector('input');
      if (/^pk/.test(n) && s.getAttribute('data-keys')) {
        // keep only the lines that still exist; fall back to every line of the variant
        var byKey = {}; list.forEach(function (it) { byKey[it.key] = it; });
        var ks = s.getAttribute('data-keys').split(',').filter(function (k) { return k && byKey[k]; });
        var mine = ks.length ? ks.map(function (k) { return byKey[k]; }) : list;
        s.setAttribute('data-keys', mine.map(function (it) { return it.key; }).join(','));
        s.setAttribute('data-qs', mine.map(function (it) { return it.quantity; }).join(','));
        if (mine.length) input.setAttribute('value', mine.reduce(function (a, it) { return a + it.quantity; }, 0));
        if (mine.length) s.setAttribute('data-key', mine[mine.length - 1].key);
      } else if (n === 'pack') {
        var total = list.reduce(function (a, it) { return a + it.quantity; }, 0);
        if (list.length) input.setAttribute('value', total);
        if (list.length) { s.setAttribute('data-key', list[list.length - 1].key); s.setAttribute('data-lq', list[list.length - 1].quantity); }
      } else {
        var it = list[+n];
        // A cart reply without this line is stale (another app's request that started before our add,
        // e.g. UpPush writing its cart attributes on page load). Leave the line alone; the drawer's own
        // refresh settles it. Zeroing it here showed "0" next to a product that was in the cart.
        // A deal can split one line in two (1 discounted unit + the rest). Until the server
        // re-render merges them, the single line on screen keeps showing the full quantity.
        var only = w.querySelectorAll('.sc-scroll .sc-step[data-vid="' + s.getAttribute('data-vid') + '"]').length === 1;
        if (it && only && list.length > 1) input.setAttribute('value', list.reduce(function (a, x) { return a + x.quantity; }, 0));
        else if (it) { s.setAttribute('data-key', it.key); input.setAttribute('value', it.quantity); }
      }
    });
  }

  function change(key, qty) { // kept for SSTCart.change()
    return post('cart/change.js', { id: key, quantity: qty, sections: SECTION })
      .then(function (res) { if (res.ok) swap(res.j.sections && res.j.sections[SECTION]); else refresh(); });
  }

  /* ---------- adds ---------- */
  /* ---------- predicted lines: draw the line exactly as the server will ----------
     Placement follows the Liquid: GrabRail parts go in the GrabRail card, a product
     that completes a Bundler bundle joins its partner's card, anything else gets its
     own card as the first non-GrabRail card (Shopify lists the newest line first).
     For percentage bundles the discount is predicted too, so the server re-render
     that follows changes nothing on screen. */
  var bundles = [];
  function loadBundles(tries) {
    tries = tries || 0;
    if (!(window.bndlr && bndlr.getBundles)) { if (tries < 40) setTimeout(function () { loadBundles(tries + 1); }, 500); return; }
    try {
      Promise.resolve(bndlr.getBundles()).then(function (bs) {
        bundles = (Array.isArray(bs) ? bs : Object.values(bs || {})).filter(function (b) { return b.status === 'enabled'; }).map(function (b) {
          var prods = Array.isArray(b.products) ? b.products : Object.values(b.products || {});
          var pids = prods.map(function (p) { return String(p.id); }), req = b.minimum_requirements, tiers = null;
          if (req === 'tiered_n_products') {
            try { tiers = (typeof b.volume_discounts === 'string' ? JSON.parse(b.volume_discounts) : b.volume_discounts || [])
              .filter(function (t) { return t.discount_type === 'percentage'; })
              .map(function (t) { return { min: +t.min_items || 2, pct: parseFloat(t.discount_value) || 0 }; }); } catch (e) { tiers = []; }
          }
          return { name: b.name || b.title, type: b.discount_type, pct: parseFloat(b.percentage_value) || 0, tiers: tiers,
            // only n_products and tiered bundles discount on their own in the cart; others need Bundler's widget
            min: req === 'n_products' ? (+b.minimum_requirements_num || 2) : 0, auto: req === 'n_products' || req === 'tiered_n_products',
            pids: pids };
        });
        if (!bundles.length && tries < 40) setTimeout(function () { loadBundles(tries + 1); }, 500);
      });
    } catch (e) {}
  }
  /* ---------- SST bundle rules (Shopify automatic discounts, see snippets/sst-bundle-rules) ---------- */
  var rules = [];
  function loadRules() {
    rules = (window.SSTBundles || []).map(function (r) {
      return { title: r.title, label: r.label, type: r.type, pct: +r.pct || 0, min: +r.min || 1, max: +r.max || 0, order: r.order || '', solo: !!r.solo,
        buy: (r.buy || []).map(String), get: (r.get || []).map(String), getv: (r.getv || []).map(String) };
    });
  }
  // Bundler's own bundles win while they're still switched on; once they're off, the rules drive predictions
  function nativeOn() { return rules.length > 0 && !bundles.length; }
  function ruleByTitle(t) { return rules.filter(function (r) { return r.title === t; })[0]; }
  function pidOf(l) { return l.getAttribute('data-pid'); }
  function qtyOf(l) { var i = l.querySelector('input'); return i ? (parseInt(i.value, 10) || 0) : 0; }
  // Re-price every line in a rule's card the way Shopify will. Returns whether the bundle still applies.
  function reprice(card) {
    var r = ruleByTitle(card.getAttribute('data-rule')); if (!r) return false;
    return priceRule(r, Array.prototype.slice.call(card.querySelectorAll('.sc-line')));
  }
  /* "solo" rules (Identibolt PRO 25%) never group cards: every product keeps its own
     card where it is, and only the green tag moves to whichever unit gets the deal.
     The deal is worked out over the whole drawer, the same way Shopify does it. */
  function repriceSolo() {
    if (!nativeOn()) return;
    var w = wrap(), sc = w && w.querySelector('.sc-scroll'); if (!sc) return;
    rules.forEach(function (r) {
      if (!r.solo) return;
      var lines = Array.prototype.filter.call(sc.querySelectorAll('.sc-card:not([data-card="grabrail"]) .sc-line[data-pid]:not(.is-gone)'), function (l) {
        return r.buy.indexOf(pidOf(l)) >= 0 || r.get.indexOf(pidOf(l)) >= 0;
      });
      if (lines.length) priceRule(r, lines);
    });
  }
  function priceRule(r, lines) {
    var offs = new Map(), names = new Map(), ok = false;
    if (r.type === 'bxgy') {
      var avail = 0; lines.forEach(function (l) { if (r.buy.indexOf(pidOf(l)) >= 0) avail += qtyOf(l); });
      if (r.max) avail = Math.min(avail, r.max);   // deals per order cap
      var unit = function (l) { var q = qtyOf(l); return q ? Math.round(lineOrig(l) / q) : 0; };
      // the discount lands on the cheapest qualifying units first (Shopify's default), or the priciest for order=high
      var gets = lines.filter(function (l) { return r.get.indexOf(pidOf(l)) >= 0 && (!r.getv.length || r.getv.indexOf(l.getAttribute('data-vid')) >= 0); })
        .map(function (l, i) { return { l: l, i: i }; })
        .sort(function (a, b) { var d = r.order === 'high' ? unit(b.l) - unit(a.l) : unit(a.l) - unit(b.l); return d || a.i - b.i; })
        .map(function (x) { return x.l; });
      lines.forEach(function (l) { offs.set(l, 0); });
      gets.forEach(function (l) {
        var q = qtyOf(l), d = Math.min(q, avail); avail -= d;
        if (d > 0 && q) { offs.set(l, Math.floor(unit(l) * r.pct / 100 + 1e-6) * d); ok = true; } // per unit, fraction of a cent dropped (as Shopify does)
        if (d > 0 && d < q) names.set(l, r.label + ' · ' + d + ' of ' + q);
      });
    } else if (r.type === 'pair') {
      // "second one" deals: once `min` units are in, the priciest unit gets pct off (one per order),
      // so the add-another offer on the PDP shows the saving the customer actually gets
      var units = 0, cheap = null, cu = -1;
      lines.forEach(function (l) {
        if (r.buy.indexOf(pidOf(l)) < 0) return;
        var q = qtyOf(l); units += q;
        if (q) { var u = Math.round(lineOrig(l) / q); if (u > cu) { cu = u; cheap = l; } }
      });
      ok = units >= r.min && !!cheap;
      lines.forEach(function (l) { offs.set(l, ok && l === cheap ? Math.floor(cu * r.pct / 100 + 1e-6) : 0); });
      if (ok && qtyOf(cheap) > 1) names.set(cheap, r.label + ' · 1 of ' + qtyOf(cheap));
    } else {
      var tot = 0; lines.forEach(function (l) { if (r.buy.indexOf(pidOf(l)) >= 0) tot += qtyOf(l); });
      ok = tot >= r.min;
      lines.forEach(function (l) { offs.set(l, ok && r.buy.indexOf(pidOf(l)) >= 0 ? Math.floor(lineOrig(l) * r.pct / 100 + 1e-6) : 0); });
    }
    var delta = 0;
    offs.forEach(function (off, l) { delta += off > 0 ? setDiscount(l, off, names.get(l) || r.label) : clearDiscount(l); });
    bumpTotal(delta);
    return ok;
  }
  // Put a freshly drawn line where Shopify will: into its bundle's card, or next to the
  // product that completes the bundle. Returns false when no rule applies.
  function nativePlace(sc, it, line, firstOther, grCard, head) {
    var pid = String(it.pid), target = null, rule = null;
    rules.some(function (x) {
      if (x.solo) return false;
      var isGetV = x.get.indexOf(pid) >= 0 && (!x.getv.length || x.getv.indexOf(String(it.vid)) >= 0);
      if (x.buy.indexOf(pid) < 0 && !isGetV) return false;
      var card = sc.querySelector('.sc-card[data-rule="' + x.title.replace(/"/g, '\\"') + '"]');
      if (card && isGetV && x.buy.indexOf(pid) < 0 && x.max) {
        // the deal is already used up by another variant: this one keeps its own card (as the server will draw it)
        var taken = Array.prototype.filter.call(card.querySelectorAll('.sc-line[data-pid]'), function (l) {
          return x.get.indexOf(pidOf(l)) >= 0 && l.getAttribute('data-vid') !== String(it.vid) && l.querySelector('.sc-disc');
        }).length;
        if (taken >= x.max) return false;
      }
      if (card) { target = card; rule = x; return true; }
      var other = x.type === 'bxgy' ? (x.buy.indexOf(pid) >= 0 ? x.get : x.buy) : x.buy;
      var partner = Array.prototype.filter.call(sc.querySelectorAll('.sc-card:not([data-rule]):not([data-card="grabrail"]) .sc-line[data-pid]'), function (l) {
        return other.indexOf(pidOf(l)) >= 0 && (x.type === 'bxgy' || pidOf(l) !== pid || true);
      })[0];
      if (partner && partner.closest('.sc-card').querySelectorAll('.sc-line').length === 1) {
        if (x.type === 'qty' || x.type === 'pair') {
          var q = it.quantity; Array.prototype.forEach.call(sc.querySelectorAll('.sc-line[data-pid]'), function (l) { if (x.buy.indexOf(pidOf(l)) >= 0) q += qtyOf(l); });
          if (q < x.min) return false;
        }
        target = partner.closest('.sc-card'); rule = x; return true;
      }
      return false;
    });
    if (!target) return false;
    target.setAttribute('data-card', 'bundle'); target.setAttribute('data-rule', rule.title);
    target.insertBefore(line, target.firstChild);
    // the newest line leads the cart, so its card moves to the top
    if (firstOther && firstOther !== target) firstOther.before(target);
    else if (!firstOther) (grCard || head).after(target);
    // pull every other single-card member of a "qty" bundle in too
    if (rule.type === 'qty' || rule.type === 'pair') Array.prototype.forEach.call(sc.querySelectorAll('.sc-card:not([data-rule]):not([data-card="grabrail"]) .sc-line[data-pid]'), function (l) {
      if (rule.buy.indexOf(pidOf(l)) >= 0) { var c = l.closest('.sc-card'); if (c.querySelectorAll('.sc-line').length === 1) { target.appendChild(l); c.remove(); } }
    });
    reprice(target);
    return true;
  }

  var SVG_MINUS = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="7.5" fill="none" stroke="currentColor" stroke-width="1.3"/><path d="M5.5 9h7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  var SVG_PLUS = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="7.5" fill="none" stroke="currentColor" stroke-width="1.3"/><path d="M5.5 9h7M9 5.5v7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  var SVG_X = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var SVG_CHECK = '<svg class="sc-check" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="6.3" fill="currentColor"/><path d="M4.2 7.2l1.9 1.9 3.7-4" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function lineMarkup(it) {
    var opts = (it.options || []).map(function (o) { return '<span class="k" title="' + esc(o.name) + '">' + esc(o.name) + '</span><span class="v" title="' + esc(o.value) + '">' + esc(o.value) + '</span>'; }).join('');
    var unit = Math.round(it.orig / it.quantity);
    return '<div class="sc-line" data-key="' + esc(it.key || '') + '" data-vid="' + it.vid + '" data-pid="' + it.pid + '" data-n="' + it.n + '" data-orig="' + it.orig + '" data-cmp="' + (it.cmp || 0) + '" data-i="-1">' +
      '<span class="sc-thumb"></span><div class="sc-body">' +
      '<div class="sc-top"><span class="sc-ttl">' + esc(it.title) + '</span><button type="button" class="sc-rm" data-act="rm" aria-label="Remove ' + esc(it.title) + '">' + SVG_X + '</button></div>' +
      (opts ? '<div class="sc-opts">' + opts + '</div>' : '') +
      '<div class="sc-bottom">' +
        '<div class="sc-step" data-key="' + esc(it.key || '') + '" data-vid="' + it.vid + '" data-n="' + it.n + '" data-unit="' + unit + '" data-wunit="0">' +
          '<button type="button" data-act="dec" aria-label="Decrease quantity">' + SVG_MINUS + '</button>' +
          '<input type="number" inputmode="none" min="0" value="' + it.quantity + '" data-act="qty" readonly tabindex="-1" aria-label="Quantity">' +
          '<button type="button" data-act="inc" aria-label="Increase quantity">' + SVG_PLUS + '</button></div>' +
        '<div class="sc-price"><span class="sc-now">' + money(it.orig) + '</span></div>' +
      '</div></div></div>';
  }
  /* How Bundler's discount lands per line (matches live carts to the cent):
     total = ceil(sum * pct), every line but the largest gets floor(own * pct),
     the largest takes what's left. */
  function allocate(lines, pct) {
    var origs = lines.map(lineOrig);
    var sum = origs.reduce(function (a, b) { return a + b; }, 0); if (!sum) return [];
    var total = Math.ceil(sum * pct / 100 - 1e-6);
    var big = 0; origs.forEach(function (o, i) { if (o > origs[big]) big = i; });
    var amt = origs.map(function (o) { return Math.floor(o * pct / 100 + 1e-6); });
    amt[big] = 0; amt[big] = total - amt.reduce(function (a, b) { return a + b; }, 0);
    return amt;
  }
  function setDiscount(line, off, name) {
    var orig = lineOrig(line); if (!orig) return 0;
    var final = orig - off;
    var price = line.querySelector('.sc-price'), now = price.querySelector('.sc-now');
    var before = parsePrice(now.textContent);
    now.textContent = money(final); now.classList.add('is-g');
    if (!price.querySelector('s')) { var s = document.createElement('s'); price.appendChild(s); }
    price.querySelector('s').textContent = money(orig);
    var bottom = line.querySelector('.sc-bottom');
    bottom.classList.add('has-disc');
    var cap = bottom.querySelector('.sc-disc');
    if (!cap) { cap = document.createElement('span'); cap.className = 'sc-disc'; bottom.appendChild(cap); }
    cap.innerHTML = SVG_CHECK + '<span>' + esc(name) + '</span>';
    var step = line.querySelector('.sc-step'); if (step) step.setAttribute('data-unit', Math.round(final / (parseInt(step.querySelector('input').value, 10) || 1)));
    return final - before;
  }
  function parsePrice(t) { return Math.round(parseFloat(String(t).replace(/[^0-9.]/g, '')) * 100) || 0; }

  // would this product pair up with something already in the cart?
  function wouldBundle(sc, pid) {
    pid = String(pid);
    return bundles.some(function (x) {
      if (!x.auto || x.type !== 'percentage' || x.pids.indexOf(pid) < 0) return false;
      var sel = x.pids.map(function (p) { return '.sc-card:not([data-card="grabrail"]) .sc-line[data-pid="' + p + '"]'; }).join(',');
      var pool = Array.prototype.slice.call(sc.querySelectorAll(sel));
      if (x.tiers) return pool.length > 0;
      return pool.some(function (l) { return l.getAttribute('data-pid') !== pid && !l.querySelector('.sc-bottom.has-disc'); });
    });
  }
  // lines of the same variant in one card show as one line (the server does the same)
  function mergeVisual(card) {
    var first = {};
    Array.prototype.slice.call(card.querySelectorAll('.sc-line:not([data-custom])')).forEach(function (l) {
      var v = l.getAttribute('data-vid'), keep = first[v];
      if (!keep) { first[v] = l; return; }
      var ki = keep.querySelector('input'), li = l.querySelector('input');
      var q = (parseInt(ki.value, 10) || 0) + (parseInt(li.value, 10) || 0);
      ki.value = q; ki.setAttribute('value', (parseInt(ki.getAttribute('value'), 10) || 0) + (parseInt(li.getAttribute('value'), 10) || 0));
      var kn = keep.querySelector('.sc-now'), ln = l.querySelector('.sc-now');
      var now = parsePrice(kn.textContent) + parsePrice(ln.textContent); kn.textContent = money(now);
      var ks = keep.querySelector('.sc-price s'), ls = l.querySelector('.sc-price s');
      if (ks && ls) ks.textContent = money(parsePrice(ks.textContent) + parsePrice(ls.textContent));
      keep.setAttribute('data-orig', (+keep.getAttribute('data-orig') || 0) + (+l.getAttribute('data-orig') || 0));
      var st = keep.querySelector('.sc-step'); if (st && q) st.setAttribute('data-unit', Math.round(now / q));
      bury(l);
    });
  }

  function provisional(items, imgNode) {
    var w = wrap(); if (!w || !items || !items.length) return;
    var sc = w.querySelector('.sc-scroll'), head = w.querySelector('.sc-head'); if (!sc || !head) return;
    var empty = sc.querySelector('.sc-empty'); if (empty) empty.remove();
    var touched = [];
    items.forEach(function (it) {
      // same variant already in the cart without line properties: Shopify adds to that line
      // same plain product already shown on its own (no discount): Bundler will put the new
      // unit on a line of its own, and the drawer shows those lines as one, so bump it
      // with Shopify's own discounts a repeat add stacks onto the line already shown (wherever it is)
      var same = nativeOn() ? (!it.custom && !it.grabrail && sc.querySelector('.sc-card:not([data-card="grabrail"]) .sc-line[data-vid="' + it.vid + '"]:not([data-custom])'))
        : !it.custom && !it.grabrail && !wouldBundle(sc, it.pid) && Array.prototype.filter.call(
        sc.querySelectorAll('.sc-card:not([data-card]) .sc-line[data-vid="' + it.vid + '"]:not([data-custom])'),
        function (l) { return !l.querySelector('.sc-bottom.has-disc'); })[0];
      if (same) {
        var st = same.querySelector('.sc-step'), inp = st.querySelector('input');
        var q = (parseInt(inp.value, 10) || 0) + it.quantity, unit = +st.getAttribute('data-unit') || Math.round(it.orig / it.quantity);
        var oq = parseInt(inp.getAttribute('value'), 10) || 1;
        same.setAttribute('data-orig', Math.round((+same.getAttribute('data-orig') || 0) / oq * q)); // keep the full price in step with the new quantity
        inp.value = q; inp.setAttribute('value', q);
        same.querySelector('.sc-now').textContent = money(unit * q);
        bumpCount(it.quantity); bumpTotal(unit * it.quantity);
        var rc = nativeOn() && same.closest('.sc-card[data-rule]'); if (rc) reprice(rc);
        repriceSolo();
        touched.push(same);
        return;
      }
      it.n = sc.querySelectorAll('.sc-line[data-vid="' + it.vid + '"]').length;
      var holder = document.createElement('div'); holder.innerHTML = lineMarkup(it);
      var line = holder.firstChild;
      touched.push(line);
      var th = line.querySelector('.sc-thumb');
      if (imgNode) th.appendChild(imgNode);
      else if (it.image) { var im = new Image(); im.alt = ''; im.decoding = 'async'; im.width = 120; im.height = 120; im.src = it.image + (it.image.indexOf('?') < 0 ? '?' : '&') + 'width=300'; th.appendChild(im); }

      var grCard = sc.querySelector('.sc-card[data-card="grabrail"]');
      var firstOther = grCard ? grCard.nextElementSibling : head.nextElementSibling;
      while (firstOther && !firstOther.classList.contains('sc-card') && !firstOther.matches('[data-ups], .sc-ship, .sc-co')) firstOther = firstOther.nextElementSibling;
      var delta = it.orig;

      if (it.grabrail) {
        if (!grCard) { grCard = document.createElement('div'); grCard.className = 'sc-card is-new'; grCard.setAttribute('data-card', 'grabrail'); head.after(grCard); }
        grCard.insertBefore(line, grCard.firstChild);
      } else if (nativeOn() && nativePlace(sc, it, line, firstOther, grCard, head)) {
        // placed and priced by an SST bundle rule
      } else {
        // does this complete a bundle with something already in the cart?
        var pid = String(it.pid), plan = null;
        bundles.some(function (x) {
          if (!x.auto || x.pids.indexOf(pid) < 0 || x.type !== 'percentage') return false;
          var sel = x.pids.map(function (p) { return '.sc-card:not([data-card="grabrail"]) .sc-line[data-pid="' + p + '"]'; }).join(',');
          var pool = Array.prototype.slice.call(sc.querySelectorAll(sel));
          var pct = 0, members;
          if (x.tiers) {
            // tiered: joins the family's existing card, tier from the total quantity
            var anchor = pool[0]; if (!anchor) return false;
            members = Array.prototype.slice.call(anchor.closest('.sc-card').querySelectorAll('.sc-line[data-pid]')).filter(function (l) { return x.pids.indexOf(l.getAttribute('data-pid')) >= 0; });
            var qty = it.quantity; members.forEach(function (l) { qty += parseInt(l.querySelector('input').value, 10) || 0; });
            x.tiers.forEach(function (t) { if (qty >= t.min && t.pct > pct) pct = t.pct; });
          } else {
            // fixed set: only partners not already used by a discount count
            var free = pool.filter(function (l) { return !l.querySelector('.sc-bottom.has-disc') && l.getAttribute('data-pid') !== pid; });
            var seen = {}; members = free.filter(function (l) { var p = l.getAttribute('data-pid'); if (seen[p]) return false; seen[p] = 1; return true; });
            if (!members.length || members.length + 1 < (x.min || 2)) return false;
            pct = x.pct;
          }
          if (!pct) return false;
          plan = { b: x, pct: pct, members: members };
          return true;
        });
        var mateCard = plan && plan.members[0].closest('.sc-card');
        if (mateCard) {
          var b = plan.b;
          if (mateCard.querySelectorAll('.sc-line').length > plan.members.length) {
            // partner shares a card with other things: pull the bundle into its own card
            var nc = document.createElement('div'); nc.className = 'sc-card';
            plan.members.forEach(function (l) { nc.appendChild(l); });
            mateCard = nc;
          }
          mateCard.setAttribute('data-card', 'bundle');
          mateCard.insertBefore(line, mateCard.firstChild);
          if (firstOther && firstOther !== mateCard) firstOther.before(mateCard);
          else if (!firstOther) (grCard || head).after(mateCard);
          var group = [line].concat(plan.members), offs = allocate(group, plan.pct);
          group.forEach(function (l, i) {
            var d = setDiscount(l, offs[i], b.name);
            if (l === line) delta += d; else bumpTotal(d);
          });
          // a second copy of the same bundle shares one discount, so Shopify shows both in one card
          var same = Array.prototype.filter.call(sc.querySelectorAll('.sc-card[data-card="bundle"]'), function (c) {
            if (c === mateCard) return false;
            var cap = c.querySelector('.sc-disc span');
            return cap && cap.textContent === b.name && Array.prototype.every.call(c.querySelectorAll('.sc-line'), function (l) { return b.pids.indexOf(l.getAttribute('data-pid')) >= 0; });
          })[0];
          if (same) {
            Array.prototype.slice.call(mateCard.querySelectorAll('.sc-line')).forEach(function (l) { same.appendChild(l); });
            Array.prototype.slice.call(same.querySelectorAll('.sc-line')).sort(function (x, y) { return +x.getAttribute('data-i') - +y.getAttribute('data-i'); }).forEach(function (l) { same.appendChild(l); });
            mateCard.remove();
            (grCard || head).after(same); // newest line is in it, so it leads the list
          }
          mergeVisual(same || mateCard);
        } else {
          var card = document.createElement('div'); card.className = 'sc-card is-new'; card.appendChild(line);
          // Shopify puts a second line of a variant right after the existing one
          var twins = sc.querySelectorAll('.sc-card:not([data-card="grabrail"]) .sc-line[data-vid="' + it.vid + '"]');
          var twin = twins[twins.length - 1];
          if (twin) { twin.closest('.sc-card').after(card); line.setAttribute('data-i', (+twin.getAttribute('data-i') || 0) + 0.5); }
          else if (firstOther && firstOther.classList.contains('sc-card')) firstOther.before(card);
          else if (grCard) grCard.after(card); else head.after(card);
        }
      }
      bumpCount(it.quantity);
      bumpTotal(delta);
      repriceSolo();
    });
    return touched;
  }
  // normalize Shopify line JSON (from /cart/add.js) for provisional()
  function fromCartJSON(list) {
    return list.map(function (i) {
      var props = i.properties || {};
      var visible = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && props[k] && k !== 'offer'; });
      var opts = i.product_has_only_default_variant ? [] : (i.options_with_values || []).filter(function (o) { return o.name !== 'Title'; });
      visible.forEach(function (k) { if (!(i.product_type === 'GrabRail Part' && k === 'Twist locks')) opts.push({ name: k, value: props[k] }); });
      return { key: i.key, vid: i.variant_id, pid: i.product_id, title: i.product_title, quantity: i.quantity, orig: i.original_line_price,
        image: i.image, options: opts, hasProps: Object.keys(props).length > 0, custom: visible.length > 0, grabrail: i.product_type === 'GrabRail Part' };
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var SVG_TICK = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.4l3 3 6-6.4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Bounce the new line in at the top. The drawer glides up to it first, and the
     server re-render picks the animation up where it left off (see swap). */
  var pop = null;
  function popTarget(line) { var card = line.closest('.sc-card'); return card && card.querySelectorAll('.sc-line').length === 1 ? card : line; }
  function popLine(line) {
    var w = wrap(), sc = w && w.querySelector('.sc-scroll'); if (!sc) return;
    var tg = popTarget(line);
    var goal = 0; // all the way up, so the "Cart" header shows above the new line
    var travel = Math.abs(sc.scrollTop - goal), delay = travel > 4 ? Math.min(420, 160 + travel / 4) : 0;
    if (travel > 4) sc.scrollTo({ top: goal, behavior: 'smooth' });
    pop = { vid: line.getAttribute('data-vid'), n: line.getAttribute('data-n'), t0: performance.now() + delay, goal: goal };
    startPop(tg, delay);
  }
  function startPop(tg, delay) {
    tg.classList.remove('is-new', 'is-pop'); void tg.offsetWidth;
    tg.style.animationDelay = Math.round(delay) + 'ms';
    tg.classList.add('is-pop');
    tg.addEventListener('animationend', function f(e) { if (e.target !== tg) return; tg.classList.remove('is-pop'); tg.style.animationDelay = ''; tg.removeEventListener('animationend', f); });
  }
  var POP_MS = 620;

  /* Bundler tags every add with a unique property, so Shopify never stacks a repeat
     add onto the line that's already there. Repeat adds of a plain product bump the
     existing line's quantity instead (Bundler re-prices it correctly). */
  function mergeTarget(vid) {
    var w = wrap(), sc = w && w.querySelector('.sc-scroll'); if (!sc) return null;
    var l = sc.querySelector('.sc-card:not([data-card="grabrail"]) .sc-line[data-vid="' + vid + '"]:not([data-custom]):not(.is-gone)');
    var st = l && l.querySelector('.sc-step');
    return st ? { line: l, step: st } : null;
  }
  function bumpLine(t, q) {
    var cur = shown(t.step);
    enqueue({ kind: 'set', vid: t.step.getAttribute('data-vid'), n: t.step.getAttribute('data-n'), value: cur + q });
    popLine(t.line);
  }

  var upsTimer;
  function renewUpsells(fromPid) {
    var w = wrap(), grid = w && w.querySelector('[data-ups-grid]'); if (!grid) return;
    if (!isOpen()) { grid.querySelectorAll('.sc-ut.is-added').forEach(function (t) { t.remove(); }); loadUpsells(fromPid); return; }
    grid.classList.add('is-swapping');
    setTimeout(function () {
      grid.querySelectorAll('.sc-ut.is-added').forEach(function (t) { t.remove(); });
      loadUpsells(fromPid).then(function () {
        requestAnimationFrame(function () { grid.classList.remove('is-swapping'); });
      });
    }, 150);
  }

  function addVariant(id, btn) {
    // the tile already has everything the new line needs, so draw it before the request
    var tile = btn && btn.closest('.sc-ut');
    var img = tile && tile.querySelector('img');
    var mt = window.SST_MERGE && mergeTarget(id);
    if (mt) {
      bumpLine(mt, 1);
      if (tile) { tile.classList.add('is-added'); btn.innerHTML = SVG_TICK + '<span>Added</span>'; btn.setAttribute('aria-disabled', 'true'); btn.tabIndex = -1;
        var ap = tile.getAttribute('data-pid'); fetchRecs(ap); clearTimeout(upsTimer); upsTimer = setTimeout(function () { renewUpsells(ap); }, 1200); }
      return Promise.resolve();
    }
    if (tile) {
      var opts = []; try { opts = JSON.parse(tile.getAttribute('data-opts') || '[]'); } catch (e) {}
      var made = provisional([{ key: '', vid: +id, pid: tile.getAttribute('data-pid'), title: tile.getAttribute('data-title'), quantity: 1,
        orig: +tile.getAttribute('data-price') || 0, options: opts, hasProps: false, custom: false, grabrail: tile.getAttribute('data-gr') === '1' }], img ? img.cloneNode() : null);
      // the tile stays put, greyed out, so the row doesn't reshuffle under the cursor
      tile.classList.add('is-added');
      btn.innerHTML = SVG_TICK + '<span>Added</span>'; btn.setAttribute('aria-disabled', 'true'); btn.tabIndex = -1;
      if (made && made[0]) popLine(made[0]);
      // after a beat, swap the row for a fresh set of picks
      var addedPid = tile.getAttribute('data-pid'); fetchRecs(addedPid);
      clearTimeout(upsTimer); upsTimer = setTimeout(function () { renewUpsells(addedPid); }, 1200);
    }
    addPending++;
    return whenSettled().then(function () { return post('cart/add.js', { items: [{ id: +id, quantity: 1 }], sections: SECTION }); })
      .then(function (res) {
        addPending--; settle(3200);
        if (!res.ok) { flash(res.j.description || 'Couldn’t add that item.'); lastHTML = ''; return refresh(); }
        var html = res.j.sections && res.j.sections[SECTION];
        if (running) pendingHTML = html; else swap(html);
      })
      .catch(function () { addPending = Math.max(0, addPending - 1); flash('Couldn’t reach the cart. Check your connection.'); lastHTML = ''; return refresh(); });
  }

  function flash(msg) {
    var w = wrap(); if (!w) return;
    var t = w.querySelector('.sc-flash');
    if (!t) { t = document.createElement('div'); t.className = 'sc-flash'; t.setAttribute('role', 'status'); w.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(flash.t); flash.t = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ---------- open / close ---------- */
  var closeTimer;
  function open(doRefresh) {
    var d = el(); if (!d) return;
    clearTimeout(closeTimer);
    document.documentElement.classList.add('cart-opening');
    document.body.classList.add('cart-opening');
    d.classList.add('is-active');
    void d.offsetWidth; // start the slide on this frame
    d.classList.add('is-visible');
    if (doRefresh !== false) refresh();
    loadUpsells(null, true);
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-visible');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      d.classList.remove('is-active');
      d.querySelectorAll('.sc-ut.is-added').forEach(function (t) { t.remove(); });
      clearTimeout(upsTimer); upsPid = null;
      loadUpsells();
      document.documentElement.classList.remove('cart-opening');
      document.body.classList.remove('cart-opening');
    }, 200);
  }
  function isOpen() { var d = el(); return !!(d && d.classList.contains('is-visible')); }

  /* ---------- upsells ---------- */
  function titleCase(s) {
    return s.split(' ').map(function (w) {
      if (/^[A-Z0-9]{2,4}$/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');
  }
  function fetchRecs(pid) {
    if (recCache[pid]) return Promise.resolve(recCache[pid]);
    if (recLoading[pid]) return recLoading[pid];
    recLoading[pid] = _fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        recCache[pid] = j.products || [];
        // warm the image cache so tiles appear with photos
        recCache[pid].slice(0, 6).forEach(function (p) { if (p.featured_image) { var i = new Image(); i.src = imgUrl(p.featured_image); } });
        return recCache[pid];
      })
      .catch(function () { return []; });
    return recLoading[pid];
  }
  function imgUrl(src) { src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=300'; }
  // fromPid: draw picks related to this product (the one just added) instead of the box's default
  var upsPid = null; // sticks until the drawer closes so later re-renders don't reshuffle the row
  function loadUpsells(fromPid, soft) {
    if (fromPid) upsPid = fromPid;
    var w = wrap(); if (!w) return Promise.resolve();
    var box = w.querySelector('[data-ups]'), grid = box && box.querySelector('[data-ups-grid]');
    if (!box || !grid) return Promise.resolve();
    var pid = upsPid || box.getAttribute('data-pid');
    if (!pid) { box.hidden = true; return Promise.resolve(); }
    if (grid.querySelector('.sc-ut.is-added')) { box.hidden = false; return Promise.resolve(); }
    // anything already drawn in the cart counts as in the cart, even before the server confirms it
    var inCart = (box.getAttribute('data-in-cart') || '').split(',').concat(Array.prototype.map.call(w.querySelectorAll('.sc-scroll .sc-line[data-pid]'), function (l) { return l.getAttribute('data-pid'); }));
    // Soft refresh (after a cart redraw or on open): the picks only change when something was
    // added. Removing an item or changing a quantity leaves the row exactly as it is.
    if (soft && grid.children.length && !Array.prototype.some.call(grid.children, function (c) { return inCart.indexOf(c.getAttribute('data-pid')) >= 0; })) {
      box.hidden = false; return Promise.resolve();
    }
    return fetchRecs(pid).then(function (products) {
      var b2 = wrap() && wrap().querySelector('[data-ups]'); if (b2 !== box) return;
      var picks = products.filter(function (p) { return inCart.indexOf(String(p.id)) < 0 && p.available; }).slice(0, 4);
      if (!picks.length) { box.hidden = true; return; }
      var have = Array.prototype.map.call(grid.children, function (c) { return c.getAttribute('data-pid'); }).join(',');
      var want = picks.map(function (p) { return String(p.id); }).join(',');
      if (have !== want) {
        var keep = {};
        Array.prototype.forEach.call(grid.children, function (c) { keep[c.getAttribute('data-pid')] = c; });
        var frag = document.createDocumentFragment();
        picks.forEach(function (p) {
          if (keep[p.id]) { frag.appendChild(keep[p.id]); return; }
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
          var t = document.createElement('div');
          t.className = 'sc-ut'; t.setAttribute('data-pid', p.id);
          t.setAttribute('data-title', p.title); t.setAttribute('data-price', v.price);
          t.setAttribute('data-gr', (p.tags || []).indexOf('grabrail-part') >= 0 ? '1' : '0');
          var ow = (p.variants || []).length > 1 ? (p.options || []).map(function (o, i) { return { name: o.name || o, value: v.options ? v.options[i] : '' }; }) : [];
          t.setAttribute('data-opts', JSON.stringify(ow));
          t.innerHTML = '<a class="sc-ut__img" href="' + p.url + '">' + (p.featured_image ? '<img src="' + imgUrl(p.featured_image) + '" alt="" width="150" height="150" decoding="async">' : '') + '</a>' +
            '<a class="sc-ut__n" href="' + p.url + '">' + esc(titleCase(p.title)) + '</a>' +
            '<span class="sc-ut__p">' + money(v.price) + '</span>' +
            '<button type="button" class="sc-ut__b" data-add="' + v.id + '">Add to cart</button>';
          frag.appendChild(t);
        });
        grid.replaceChildren(frag);
      }
      box.hidden = false;
    });
  }

  /* Checkout waits for any cart write still in line, so nothing is left behind. */
  document.addEventListener('click', function (e) {
    var co = e.target.closest && e.target.closest('[data-sstc] .sc-co');
    if (!co || !busyWriting()) return;
    e.preventDefault();
    co.classList.add('is-wait');
    (function go() { if (busyWriting()) setTimeout(go, 120); else location.href = co.href; })();
  }, true);

  /* ---------- events (bound once) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.cart___drawer')) { e.preventDefault(); open(true); return; }
    var d = el(); if (!d || !d.contains(t)) return;
    if (t.closest('.drawer__close') || t.classList.contains('drawer__overlay')) { e.preventDefault(); close(); return; }
    var add = t.closest('[data-add]'); if (add) { addVariant(add.getAttribute('data-add'), add); return; }
    var act = t.closest('[data-act]'); if (!act) return;
    var a = act.getAttribute('data-act'); if (a === 'qty') return;
    var holder = act.closest('.sc-line'), step = act.closest('.sc-step') || (holder && holder.querySelector('.sc-step'));
    if (!step || step.classList.contains('is-ghost') || !step.getAttribute('data-key')) return;
    var kind = a === 'inc' ? 'inc' : a === 'dec' ? 'dec' : a === 'rm' ? 'rm' : null;
    if (kind) enqueue({ vid: step.getAttribute('data-vid'), n: step.getAttribute('data-n'), kind: kind });
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-sstc] input[data-act="qty"]')) return;
    var step = t.closest('.sc-step');
    var q = Math.max(0, Math.min(999, parseInt(t.value, 10) || 0));
    var prev = parseInt(t.getAttribute('data-shown') || t.getAttribute('value'), 10) || 0;
    t.value = prev; // let enqueue paint from the last shown value
    enqueue({ vid: step.getAttribute('data-vid'), n: step.getAttribute('data-n'), kind: 'set', value: q });
  });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-sstc] input[data-act="qty"]')) t.setAttribute('data-shown', t.value);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-sstc] input[data-act="qty"]')) e.target.blur();
  });

  /* The theme's product form shows a spinner until its own cart popup runs. That popup
     is gone, so stop the spinner when the add finishes (the old drawer did this too). */
  function resetAddButtons() {
    document.querySelectorAll('.product-form__cart-submit, [data-add-to-cart]').forEach(function (b) {
      b.removeAttribute('aria-disabled');
      b.classList.remove('is-loading', 'loading', 'btn--loading');
      b.querySelectorAll('[data-add-to-cart-text], .add-cart-text').forEach(function (t) { t.classList.remove('hide'); });
      b.querySelectorAll('[data-loader], span[data-loader]').forEach(function (l) { l.classList.add('hide'); });
    });
    document.querySelectorAll('[data-loader-status]').forEach(function (s) { s.setAttribute('aria-hidden', 'true'); });
  }

  /* ---------- any add-to-cart on the page opens the drawer immediately ---------- */
  function isAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }
  /* Draw an add before the request even leaves: the product JSON on the page
     already has the title, price, photo and options. */
  var pjIndex = null;
  function productIndex() {
    if (pjIndex) return pjIndex;
    pjIndex = {};
    document.querySelectorAll('script[type="application/json"][id^="ProductJson"]').forEach(function (sc) {
      try { var p = JSON.parse(sc.textContent); (p.variants || []).forEach(function (v) { pjIndex[v.id] = { p: p, v: v }; }); } catch (e) {}
    });
    return pjIndex;
  }
  function parseAddBody(body) {
    var items = [];
    var fromPairs = function (get, each) {
      var props = {}; each(function (val, k) { var m = String(k).match(/^properties\[(.+)\]$/); if (m) props[m[1]] = val; });
      if (get('id')) items.push({ id: +get('id'), quantity: +(get('quantity') || 1), properties: props });
    };
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) fromPairs(function (k) { return body.get(k); }, function (f) { body.forEach(f); });
      else if (body instanceof URLSearchParams) fromPairs(function (k) { return body.get(k); }, function (f) { body.forEach(f); });
      else if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          (j.items || [j]).forEach(function (i) { if (i.id) items.push({ id: +i.id, quantity: +(i.quantity || 1), properties: i.properties || {} }); });
        } else { var u = new URLSearchParams(body); fromPairs(function (k) { return u.get(k); }, function (f) { u.forEach(f); }); }
      }
    } catch (e) { return []; }
    return items;
  }
  function earlyItems(list) {
    var idx = productIndex(), out = [];
    for (var n = 0; n < list.length; n++) {
      var it = list[n], e = idx[it.id]; if (!e) return null;
      var p = e.p, v = e.v, props = it.properties || {}, gr = (p.tags || []).indexOf('grabrail-part') >= 0;
      var opts = (p.variants || []).length > 1 ? (p.options || []).map(function (o, i) { return { name: o.name || o, value: (v.options || [])[i] }; }) : [];
      Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_' && props[k] && k !== 'offer' && !(gr && k === 'Twist locks')) opts.push({ name: k, value: props[k] }); });
      var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      out.push({ key: '', vid: v.id, pid: p.id, title: p.title, quantity: it.quantity, orig: v.price * it.quantity, cmp: v.compare_at_price > v.price ? v.compare_at_price : 0, image: img,
        options: opts, hasProps: (!!window.bndlr && bundles.length > 0) || Object.keys(props).length > 0,
        custom: Object.keys(props).some(function (k) { return k.charAt(0) !== '_' && props[k]; }), grabrail: gr });
    }
    return out;
  }

  /* Other apps (Bundler mostly) edit the cart after an add: they re-tag lines and
     re-price bundles a second or two later. Pick those changes up so the drawer never
     sits on a stale price or key. */
  var outsideDirty = false, outsideTimer;
  function isEdit(url) { return typeof url === 'string' && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url); }
  function outsideChanged(cart) {
    if (cart && cart.items && cart.token) syncKeys(cart);
    if (busyWriting()) { outsideDirty = true; return; }
    clearTimeout(outsideTimer);
    // Bundler edits come in bursts; draw once it has gone quiet
    outsideTimer = setTimeout(function () { whenSettled().then(function () { if (busyWriting()) { outsideDirty = true; return; } lastHTML = ''; refresh(); }); }, 50);
  }

  /* An add whose products are already in the cart: bump those lines (cart/update) and
     add only what's new. Jobs run one after another so a fast run of clicks can't
     race itself or Bundler's re-tagging, and every line stays one line. */
  var addChain = Promise.resolve();
  function mergedAdd(list, targets) {
    open(false);
    var bumps = [], rest = [];
    list.forEach(function (it, i) {
      var t = targets[i];
      if (t) { paint(t.step, shown(t.step) + it.quantity); bumps.push({ vid: t.step.getAttribute('data-vid'), n: t.step.getAttribute('data-n'), q: it.quantity }); }
      else rest.push(it);
    });
    var early = rest.length ? earlyItems(rest) : null, made = early ? provisional(early) : null;
    var first = (made && made[0]) || (targets.filter(Boolean)[0] || {}).line;
    if (first) popLine(first);
    setTimeout(resetAddButtons, 0);
    var json = function (obj, status) { return new Response(JSON.stringify(obj), { status: status || 200, headers: { 'Content-Type': 'application/json' } }); };
    // a job still waiting its turn absorbs this click (one request for a burst of clicks)
    if (waitingMerge && !rest.length) {
      bumps.forEach(function (b) {
        var hit = waitingMerge.bumps.filter(function (x) { return x.vid === b.vid && x.n === b.n; })[0];
        if (hit) hit.q += b.q; else waitingMerge.bumps.push(b);
      });
      waitingMerge.list = waitingMerge.list.concat(list);
      return waitingMerge.job.then(function (r) { return r.clone(); });
    }
    var me = { bumps: bumps, list: list };
    addPending++;
    var job = addChain.then(whenSettled).then(function () {
      if (waitingMerge === me) waitingMerge = null;
      bumps = me.bumps; list = me.list;
      running = true;
      var needKeys = bumps.some(function (b) { var st = stepFor({ vid: b.vid, n: b.n }); return st && !st.getAttribute('data-key'); });
      var keys = needKeys ? _fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(syncKeys) : Promise.resolve();
      var attempt = function (retry) {
        var updates = {};
        bumps.forEach(function (b) {
          var st = stepFor({ vid: b.vid, n: b.n }); if (!st) return;
          var inp = st.querySelector('input'), server = parseInt(inp.getAttribute('value'), 10) || 0;
          updates[st.getAttribute('data-key')] = server + b.q;
        });
        return (Object.keys(updates).length ? post('cart/update.js', { updates: updates }) : Promise.resolve(null)).then(function (r1) {
          if (r1 && !r1.ok && !retry) {
            return _fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { syncKeys(c); return attempt(true); });
          }
          if (r1 && r1.ok) { syncKeys(r1.j); bumps = []; }
          return rest.length ? post('cart/add.js', { items: rest.map(function (it) { return { id: it.id, quantity: it.quantity, properties: it.properties }; }) }) : r1;
        });
      };
      return keys.then(function () { return attempt(false); });
    }).then(function (res) {
      running = false; addPending--; settle(3200);
      if (queue.length) run(); else { lastHTML = ''; refresh(); }
      if (!res) return json({ items: [] });
      if (!res.ok) { flash(res.j.description || 'Couldn’t add that item.'); return json(res.j, 422); }
      var items = res.j.items || [];
      var out = list.map(function (it) { return items.filter(function (x) { return x.variant_id === it.id; })[0]; }).filter(Boolean);
      return json(list.length === 1 && out[0] ? out[0] : { items: out });
    }, function (e) { running = false; addPending--; lastHTML = ''; refresh(); throw e; });
    me.job = job; if (!rest.length) waitingMerge = me;
    addChain = job.catch(function () {});
    return job.then(function (r) { return r.clone(); });
  }
  var waitingMerge = null;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (isEdit(url)) {
      outsideInflight++;
      var pe = _fetch(input, init);
      pe.then(function (r) { outsideInflight--; settle(1100); if (!r.ok) return; r.clone().json().then(outsideChanged, function () { outsideChanged(); }); },
        function () { outsideInflight--; });
      return pe;
    }
    var early = null;
    if (isAdd(url) && !queue.length && window.SST_MERGE) {
      var list = parseAddBody(init && init.body);
      var plain = list.length && list.every(function (it) { return Object.keys(it.properties || {}).every(function (k) { return k.charAt(0) === '_'; }); });
      var targets = plain ? list.map(function (it) { return mergeTarget(it.id); }) : [];
      if (targets.some(Boolean)) return mergedAdd(list, targets);
    }
    if (isAdd(url)) {
      open(false);
      if (!running) {
        var parsed = parseAddBody(init && init.body);
        var its = parsed.length && parsed.length <= 2 ? earlyItems(parsed) : null;
        if (its) { early = provisional(its); if (early && early[0]) popLine(early[0]); }
      }
    }
    var p = isAdd(url) ? whenSettled().then(function () { return _fetch(input, init); }) : _fetch(input, init);
    if (isAdd(url)) {
      addPending++;
      p.then(function () { addPending--; settle(3200); }, function () { addPending--; });
      p.then(function (r) {
        setTimeout(resetAddButtons, 0);
        if (!r.ok) { lastHTML = ''; refresh(); return; }
        r.clone().json().then(function (j) {
          var items = j.items || (j.id ? [j] : null);
          if (!early && items && items.length <= 2 && !running) { var made = provisional(fromCartJSON(items)); if (made && made[0]) popLine(made[0]); }
          lastHTML = ''; refresh();
        }).catch(function () { lastHTML = ''; refresh(); });
      }).catch(function () { lastHTML = ''; refresh(); });
    }
    return p;
  };
  if (window.jQuery) {
    jQuery(document).ajaxSend(function (ev, xhr, opts) { if (opts && isAdd(opts.url)) open(false); });
    jQuery(document).ajaxComplete(function (ev, xhr, opts) {
      if (opts && isEdit(opts.url)) { settle(1100); if (xhr.status >= 200 && xhr.status < 300) outsideChanged(xhr.responseJSON); }
      if (opts && isAdd(opts.url)) { setTimeout(resetAddButtons, 0); if (xhr.status >= 200 && xhr.status < 300) { lastHTML = ''; refresh(); } }
    });
  }

  // touch feedback on − / +: keep the grey for ~280ms after the finger lifts, then let CSS fade it
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('[data-sstc] .sc-step button'); if (!b) return;
    clearTimeout(b._press); b.classList.add('is-press');
    var up = function () {
      document.removeEventListener('pointerup', up, true); document.removeEventListener('pointercancel', up, true);
      b._press = setTimeout(function () { b.classList.remove('is-press'); }, 280);
    };
    document.addEventListener('pointerup', up, true); document.addEventListener('pointercancel', up, true);
  }, true);

  loadBundles(); loadRules();
  window.SSTCart = { open: open, close: close, refresh: refresh, change: change, busy: function () { return running || queue.length > 0; } };
  window.renderCart = function () { return refresh(); };

  // warm everything while the page is idle so the first open is instant
  function warm() {
    loadBundles();
    var w = wrap(); if (!w) return;
    lastHTML = '';
    loadUpsells();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { (window.requestIdleCallback || setTimeout)(warm, 300); });
  else (window.requestIdleCallback || setTimeout)(warm, 300);
})();
